import { ArrowLeftOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import SlogTab from "./Tab";
import { startZoneviewLoader } from "../../redux/zoneView/actions";
import { FETCH_ZONEVIEW_SAGA } from "../../redux/zoneView/type";

const SlogWeld = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { weld_number } = useParams();
  const selectedProjectId = useSelector(
    (state) => state?.projectReducer?.selectedProject?.project_id
  );
  const selectedProjectName = useSelector(
    (state) => state?.projectReducer?.selectedProject?.project_name
  );

  useEffect(() => {
    const params = {
      project_id: selectedProjectId,
      project_name: selectedProjectName,
      weld_number: weld_number,
    };
    dispatch(startZoneviewLoader());
    dispatch({ type: FETCH_ZONEVIEW_SAGA, payload: params });
  }, [dispatch]);

  const [, setActiveTab] = useState("1");

  return (
    <>
      <div className="slogweld-title">
        <Link to={"/data360-home"}>
          <div className="back_equip">
            <Tooltip title={"Back"}>
              <ArrowLeftOutlined />
            </Tooltip>
            <h2 className="slogweld-header-active">
              {t("slogColumntitle.logData")}
            </h2>
          </div>
        </Link>
        <div className="back_equip-unActive">
          <ArrowLeftOutlined />
          <h2 className="slogweld-header">
            {t("slogColumntitle.weld")} {weld_number}
          </h2>
        </div>
      </div>
      <SlogTab setActiveTab={setActiveTab} weld_number={weld_number} />
    </>
  );
};

export default SlogWeld;
